import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonDataService } from '@shared/services/common-data.service';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { custom } from 'devextreme/ui/dialog';
import { AuthService } from '@modules/auth/services/auth.service';
import { fetchAuthSession, signInWithRedirect, getCurrentUser } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { Keepalive } from '@ng-idle/keepalive';
import { lConfirmationPopupService } from '@data/confirmation-popup.service';
import { environment } from '@environments/environment';
import { dummyUser } from './dummyUser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false
})
export class AppComponent implements OnInit {

  idleState = 'NOT_STARTED';
  timedOut = false;
  idleEndCount = 0;
  idleStartCount = 0;
  idleTimeoutCount = 0;
  countdown: any;
  idleTimeoutWarningCount = 0;
  lastPing?: Date;
  okButton: any[] | undefined = [
    {
      text: "OK",
      type: "default",
      stylingMode: "contained",
      onClick: (e: any) => {
        return "OK";
      }
    }
  ];
  idleMessage = '';
  dummyUser=dummyUser;
  constructor(private authService: AuthService, private commonSer: CommonDataService, private router: Router, private idle: Idle,
    private zone: NgZone,
    private keepalive: Keepalive,
    private popupService: lConfirmationPopupService
  ) {
   }

  ngOnInit() {

    if (environment.bypassOktaForLocal) {
      this.localLogin()
    }
    else{
    this.checkLogin();
    this.listenToAuthEvents();
    fetchAuthSession().then((data: any) => {
      this.commonSer.createAuthorizationToken().subscribe(r => {
        if (r.status == "SUCCESS") {
          this.commonSer.getUser().subscribe(r => {
            if (r.status == "SUCCESS" && r.serviceResult.activeFlag && !window.location.pathname.includes('downloadUid')) {
              if (window.location.pathname.slice(0, 13) != '/preview-pdf/') {
                this.commonSer.fetchAllCommonData();
              }
              this.setupIdleWatchers();
              this.reset();
            }

          })
        }
      })
    })
      .catch(() => {
      });
    }
  }


  setupIdleWatchers() {
    this.idle.setIdle(3600); // 1 hour of inactivity
    this.idle.setTimeout(300); // 5 minutes countdown before timeout
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      this.idleState = "You're idle!";

      // this.popupService.customConfirmDialog({
      //   title: 'Idle Notification',
      //   showTitle: true,
      //   messageHtml: '<b>' + 'Looks like you have been idle for a while. Please save your work, the system will auto logout after 5 more minutes of inactivity.' + '</b>',
      //   buttons: this.okButton
      // }).show().then((res: any) => {
      //   if (res == 'OK') {
      //     this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      //     this.idle.stop();
      //     this.idle.watch();
      //   }
      // })
      // Do NOT log out yet — wait for timeout
    });

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      this.zone.run(() => {  // <-- important
        this.countdown = countdown;
        this.idleState = `You will be logged out in ${countdown} seconds!`;
      })
    });

    this.idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.authService.logout();  // Now log out
    });

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
    });

    this.idle.onInterrupt.subscribe(() => {
       this.commonSer.idleCookieSet();

    });

    

    this.idle.watch();
  }

  async checkLogin() {
    try {
      const user = await getCurrentUser();
    } catch (err) {
      console.log("Err", err)
      window.localStorage.setItem('postLoginRedirect', window.location.href);
      await signInWithRedirect({
        provider: {
          custom: environment.federatedProvider,
        },
        customState: "mpg",
      });
    }
  }

  listenToAuthEvents() {
    Hub.listen("auth", async (data) => {
      await fetchAuthSession();
    })
  }


  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  localLogin() {
    let r = dummyUser;
      if (r.status == "SUCCESS") {
      this.commonSer.getUser().subscribe(r => {
        if (r.status == "SUCCESS" && r.serviceResult.activeFlag && !window.location.pathname.includes('downloadUid')) {
          if (window.location.pathname.slice(0, 13) != '/preview-pdf/') {
            this.commonSer.fetchAllCommonData();
          }
          this.setupIdleWatchers();
          this.reset();
        }

      })
    }
  }

  customAlert(message: any) {
    const mpDialog = custom({
      showTitle: false,
      messageHtml: message,
      buttons: [

        {
          text: "Stay Signed In",
          onClick: (e) => {
            mpDialog.hide();
            this.reset();
          }
        },
        {
          text: "Sign Out",
          onClick: (e) => {
            this.authService.logout();
          }
        }
      ]
    });
    mpDialog.show();
  }

}
